import React from 'react'
import Box from '@mui/material/Box'
import FormLabel from '@mui/material/FormLabel'
import TooltipPopover from "@/components/shared/others/TooltipPopover"

type Props = {
  label: string
  tooltipText: string
  required?: boolean
}

const LabelPopover: React.FC<Props> = ({ label, tooltipText, required }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <FormLabel required={required}>
        {label}
      </FormLabel>
      <TooltipPopover>
        {tooltipText}
      </TooltipPopover>
    </Box>
  )
}

export default LabelPopover
